import type { BackendError } from '@/helpers/errors/collection'
import type { Ref } from 'vue'
import { ref, watch } from 'vue'

type Valid<T> = {
    valid: true
    value: T
}

type Invalid = {
    valid: false
    error: BackendError
}

export type FrontendError<ValidValue> = {
    error: Readonly<Ref<BackendError | null>>
    validate: () => ValidValue | undefined
}

export function useFrontendError<Value, ValidValue>(
    value: Readonly<Ref<Value>>,
    validate: (value: Value) => Valid<ValidValue> | Invalid
): FrontendError<ValidValue> {
    const error: Ref<BackendError | null> = ref(null)

    const innerValidate = (): ValidValue | undefined => {
        const validateResult = validate(value.value)

        if (validateResult.valid) {
            error.value = null
            return validateResult.value
        } else {
            error.value = validateResult.error
            return undefined
        }
    }

    watch(value, innerValidate)

    return {
        error,
        validate: innerValidate,
    }
}
